export enum Phrases {
  FormError = 'Please, check the form for errors',
}
